<template>
  <div class="page" id="app">
    <CommonMenu />
    <MainMenu />
    <RegionInfoOverlay
      v-if="showRegionInfoOverlay"
      @close="showRegionInfoOverlay = false"
    />
    <div class="page_content" :key="currentCountry">
      <ErrorBoundary :error="error" v-if="stateInitialized">
        <Transition name="page-transition" mode="out-in" appear>
          <RouterView />
        </Transition>
      </ErrorBoundary>
      <Spinner class="app-spinner" size="large" color="red" v-if="showSpinner" />
    </div>
    <PageFooter />
    <PortalTarget name="overlay" slim />
  </div>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator'
import { State, Mutation, Action, Getter } from 'vuex-class'

import CommonMenu from '@/common/common-menu/CommonMenu'
import Spinner from '@/common/components/Spinner'
import ErrorBoundary from '@/common/components/ErrorBoundary'
import MainMenu from '@/components/MainMenu'
import RegionInfoOverlay from '@/components/RegionSelect/RegionInfoOverlay'
import PageFooter from '@/components/PageFooter/PageFooter'
import { AVAILABLE_COUNTRIES } from '@/constants'

@Component({
  components: {
    MainMenu,
    PageFooter,
    RegionInfoOverlay,
    Spinner,
    CommonMenu,
    ErrorBoundary
  }
})
class DefaultApp extends Vue {
  @State('country') currentCountry
  @Mutation('ui/SET_SCROLL_LOCK') setScrollLock
  @Action('auth/authenticate') authenticateUser
  @Action('cards/fetchCards') fetchCards
  @Getter('auth/isAuthorized') isAuthorized
  @Getter('auth/userID') userID

  isLoading = true
  showRegionInfoOverlay = false
  error = null

  beforeCreate () {
    // const userLanguage = this.$language.getUserLanguage()
    // userLanguage && this.$language.setLanguage(userLanguage)
  }

  created () {
    this.fetchInitialData()
    if (!this.currentCountry || !AVAILABLE_COUNTRIES[this.currentCountry]) {
      this.showRegionInfoOverlay = true
    }
  }

  /**
   * All data for render app logic is ready
   * @returns {boolean}
   */
  get stateInitialized () {
    return !this.isLoading && this.currentCountry && this.isAuthorized
  }

  /**
   * Spinner should not show if country not selected
   * @returns {boolean}
   */
  get showSpinner () {
    return this.isLoading && Boolean(this.currentCountry)
  }

  async fetchInitialData () {
    try {
      this.error = null
      await this.authenticateUser()
      this.$analytics.sendUserAnalytics({ userID: this.userID })
      this.isAuthorized && await this.fetchCards({ include: ['accrual_sums'] })
    } catch (error) {
      this.error = error
    }
    this.isLoading = false
  }

  @Watch('showRegionInfoOverlay')
  onShowRegionInfoOverlayChanged (isOpen) {
    this.setScrollLock(isOpen)
  }
}

export default DefaultApp
</script>

<style lang="scss">
@import "@/common/assets/scss/common/common.scss";

.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  position: relative;

  &_content {
    flex-grow: 1;
    overflow: hidden;
    padding-top: $menu_height;
    @include media_tablet {
      padding-top: $menu_height_tablet;
    }
  }
}

.page-transition {
  &-enter-active, &-leave-active {
    transition: all .3s ease-in-out;
  }

  &-enter, &-leave-to {
    transform: translateY(50px);
    opacity: 0;
  }
}

.app-spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}
</style>
